import { Component, Output, Input, EventEmitter, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-featured-creators",
  templateUrl: "featured-creators.component.html",
  standalone: false,
})
export class FeaturedCreatorsComponent extends BaseComponent implements OnInit {
  @Output() creatorClicked: EventEmitter<any> = new EventEmitter();
  @Input() featuredCreators: Array<any>;

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit() {}
}
